export const state = () => ({
  page: 0,
  payments: [],
  filters: '',
  resultCount: 0,
});

export const getters = {
  getData(store) {
    return store.payments;
  },
  getPage(store) {
    return store.page;
  },
  getFilters(store) {
    return store.filters;
  },
  getResultCount(store) {
    return store.resultCount;
  },
};

export const mutations = {
  reset(store) {
    store.page = 0;
    store.payments = [];
    store.filters = '';
    store.resultCount = 0;
  },
  setData(store, payload) {
    store.payments = payload;
  },
  clearData(store) {
    store.payments = [];
  },
  setPage(store, payload) {
    store.page = payload;
  },
  setFilters(store, payload) {
    store.filters = payload;
  },
  setResultCount(store, payload) {
    store.resultCount = payload;
  },
};

export const actions = {
  async reset({ commit }) {
    commit('reset');
  },
  async fetchData({ commit, state }) {
    let url = 'payment?results=10&in_consolidated=1';
    if (state.page) {
      url += `&page=${state.page}`;
    }
    if (state.filters) {
      url += state.filters;
    }

    const payments = await this.$axios.$get(url);

    commit('setData', payments.payment_list);
    commit('setResultCount', payments.total);
  },
  async clearData({ commit }) {
    commit('clearData');
  },
  async setPage({ commit }, payload) {
    commit('setPage', payload);
  },
  async setFilters({ commit }, payload) {
    commit('setFilters', payload);
  },
};
